import { listOrgEnrollments } from "./enrollmentHelpers"

const scoresFor = (enrollment) => {
  const quizScores = Object.values(enrollment?.moduleQuizResults || {})?.map((r) => r?.bestScore || 0)
  const capstoneScore = enrollment?.capstoneResult?.bestScore
  return capstoneScore !== undefined ? [...quizScores, capstoneScore] : quizScores
}

// Groups existing enrollments by cohortName (already a field on every
// enrollment doc) — no new collection needed. Enrollments with no cohortName
// set are excluded, since "Ungrouped" isn't a cohort an admin can intervene on.
export const computeCohortPerformance = async (orgId) => {
  const { enrollments } = await listOrgEnrollments(orgId)
  const cohortNames = new Set(enrollments?.filter((e) => e?.cohortName)?.map((e) => e?.cohortName))

  const rows = Array.from(cohortNames)?.map((cohortName) => {
    const cohortEnrollments = enrollments?.filter((e) => e?.cohortName === cohortName) || []
    const learnerIds = new Set(cohortEnrollments?.map((e) => e?.userId))

    const completedCount = cohortEnrollments?.filter((e) => (e?.progressPercent || 0) >= 100)?.length || 0
    const completionRate = cohortEnrollments?.length ? Math.round((completedCount / cohortEnrollments.length) * 100) : 0

    const allScores = cohortEnrollments?.flatMap(scoresFor) || []
    const avgScore = allScores?.length ? Math.round(allScores?.reduce((a, b) => a + b, 0) / allScores.length) : 0

    return { cohortName, learners: learnerIds.size, completionRate, avgScore }
  })

  const orgAvgCompletion = rows?.length ? rows?.reduce((sum, r) => sum + r?.completionRate, 0) / rows.length : 0

  return rows
    ?.map((row) => ({ ...row, needsAttention: row?.completionRate < orgAvgCompletion - 10 }))
    ?.sort((a, b) => b?.learners - a?.learners)
}